import { useLocale, useTranslations } from 'next-intl';
import { useLanguages } from 'providers/ClientProviders/useLanguages';
import { Option } from 'types/Option';
import { availableLanguageOptions } from 'utils/availableLanguageOptions';
import { getMostUsedSourceLanguagesUtil } from 'utils/getMostUsedSourceLanguagesUtil';

interface IUseOptionsSourceLanguageIn {
  excluded?: string[];
}

interface IUseOptionsSourceLanguageOut {
  optionsSourceLanguages: Option[];
}

export default function useOptionsSourceLanguage({
  excluded = []
}: IUseOptionsSourceLanguageIn = {}): IUseOptionsSourceLanguageOut {
  const { data } = useLanguages();
  const locale = useLocale();
  const t = useTranslations();

  const optionsSourceLanguages = [
    {
      value: '',
      label: t('ordering_form.source_language'),
      disabled: true,
      hidden: true
    },
    ...availableLanguageOptions(
      data?.allOrderableSourceLanguages?.map((item) => item.code as string) ?? [],
      excluded,
      getMostUsedSourceLanguagesUtil(
        data?.languagePairs?.map((item) => item.sourceLanguageCode as string) ?? []
      ),
      '',
      t,
      locale
    )
  ];

  return { optionsSourceLanguages };
}
